import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

const Container = styled.div`
    box-sizing: border-box;
    align-items: center;
    padding: 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
    justify-content: space-between;
`

const Option = styled.div`
    text-transform: uppercase;
    padding: 4px 10px;
    font-size: 10px;
    background-color: ${props => props.active ? '#415dd4' : 'rgba(160, 183, 190, .24)'};
    color: ${props => props.active ? '#fff' : '#7c9198'};
    cursor: pointer;
    margin-top: 5px;
    display: inline-block;
    border-radius: 2px;
    letter-spacing: 1px;
`

class Field extends React.Component {
    handleSelect = (e) => {
        const value = this.props.entityFields.find(item => item.id === e.target.value).pathId
        this.props.handleChange(value, this.props.mapping.pdfField, 'pathId')
    }

    handleClick = () => {
        this.props.handleChange(!this.props.mapping.empty, this.props.mapping.pdfField, 'empty')
    }

    render() {
        const {intl, mapping, entityFields } = this.props

        return (
            <Container>
                <div>
                    <div>{mapping.pdfField}</div>
                    <Option
                        active={mapping.empty}
                        onClick={this.handleClick}
                    >
                        {intl.formatMessage({id: "sidebar.data_export_value_empty"})}
                    </Option>
                </div>
                {!mapping.empty &&
                    <Select
                        style={{minWidth: '230px'}}
                        value={mapping.pathId.join(',')}
                        onChange={this.handleSelect}
						variant="standard"
                    >
                        {entityFields.map(item =>
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        )}
                    </Select>
                }
            </Container>
        )
    }
}

export default injectIntl(Field)
